export const TRANSLATIONS_DA = {
    max: "Max",
    mix: "Mix",
    flex: "Flex",
    survivor8: "Survivor",
    number_of_rows_left: "Antal rækker tilbage",
    coupon_value_trend: "Kuponværdi trend",
    cash_out: "Cash out",
    cashed_out: "Cashed out",
    no_data_available: "Ingen data tilgængelig",
    rows_left: "tilbage",
    my_rows_left: "Mine rækker tilbage",
    rows_total: "total",
    eliminated: "Elimineret",
    game: "Kamp",
    start: "Start",
    actual_value: "Faktisk værdi",
    projected_home_win: "Projiceret: Hjemmesejr",
    projected_draw: "Projiceret: Uafgjort",
    projected_away_win: "Projiceret: Udesejr",
    my_bets: "Mine spil",
    my_coupons: "Mine kuponer",
    rounds: "Runder",
    bet_with_syndicates: "Fælles kupon",
    syndicates: "Fælles kupon",
    turnover: "Omsætning",
    single_rows: "Enkelt rækker",
    pro_pick: "Pooleren",
    often: "Vind ofte",
    a_lot: "Vind meget",
    system: "System",
    row_distribution: "Rækkefordeling",
    overview: "Summation",
    full_cover: "Heldagsleje",
    half_cover: "Halvdækninger",
    row_price: "Rækkepris",
    pay: "Placer et væddemål",
    pay_freebet: "Brug gratisspil",
    pay_syndicate: "Køb andel",
    print_store_receipt: "Udskriv skiltkvittering",
    unsettled_coupons: "Løbende kuponer",
    settled_coupons: "Afregnede kuponer",
    stake: "Indsats",
    coupon_share_status_cancelled: "Makuleret",
    your_winnings_right_now: "Din fortjeneste lige nu",
    correct_rows_now: "Lige nu",
    starts: "Starter",
    starts_kryss: "Spillestop",
    correct_rows: "Antal korrekte",
    prize: "Udbytte",
    your_rows: "Dine linjer",
    profit: "Gevinst",
    st: "stk.",
    total: "Resultater",
    rows: "linjer",
    row: "række",
    price_per_row: "Indsats pr. række",
    total_cost: "Samlet indsats",
    paid: "Betalt",
    settled: "Besluttet",
    channel_internet: "Spillet via: Internettet",
    print: "Trykke",
    share: "Dele",
    clear_bets: "Klar",
    reduce: "Reducere",
    no_reduced_systems_available: "Ingen reducerede systemer tilgængelige",
    round_history: "Resultater",
    no_profit: "Ingen profit",
    no_coupons: "Ingen kuponer",
    started: "Startet",
    round: "Spillerunde",
    winners: "Vinder",
    your_bet_is_paid: "Dit væddemål er placeret!",
    do_you_want_to_place_bet: "Vil du placere et væddemål på",
    do_you_want_to_place_freebet: "Vil du bruge dit gratisspil værd",
    highest_win: "Højeste profit",
    insufficient_funds: "Saldoen er for lav",
    gaming_limits_reached: "Dit væddemål kunne ikke placeres, da din indsatsgrænse er nået.",
    cancel: "Ophæve",
    unable_to_complete_purchase: "Købet kunne ikke gennemføres.",
    error_code: "Fejlkode",
    event_goal: "Mål",
    event_penalty: "Straf",
    event_missed_penalty: "Misset straffespark",
    event_own_goal: "Selvmål",
    event_var: "VAR",
    event_yellowcard: "Gult kort",
    event_yellowred: "Andet gule kort",
    event_substitution: "Forandring",
    event_redcard: "Rødt kort",
    event_pen_shootout_goal: "Mål på straffespark",
    event_pen_shootout_miss: "Misset straffespark",
    event_full_time: "Fuldtid",
    event_half_time: "Halvleg",
    event_kickoff: "Kickoff",
    event_finished_after_extra: "Ekstra tid Slut",
    out: "Ud",
    table: "Tabel",
    game_info: "Kampinfo",
    statistics: "Statistik",
    team_name: "Hold",
    table_abbreviation_num_games: "K",
    table_abbreviation_wins: "S",
    table_abbreviation_draws: "U",
    table_abbreviation_losses: "N",
    table_abbreviation_points: "P",
    round_active_after_deadline: "Lukket",
    full_time: "Fuldtid",
    round_status_finished: "Færdiggjort",
    half_time: "Halvleg",
    current_rounds: "Nuværende runder",
    settled_rounds: "Færdige runder",
    no_rounds_available: "Ingen runder tilgængelige",
    row_statistics: "Rækkestatistik",
    showing: "Viser",
    settings: "Indstillinger",
    match: "Kamp",
    result: "Resultater",
    bet_type: "Systemtype",
    mathematical_system: "Matematisk system",
    reduced_system: "Reduceret system",
    no_system: "Intet system",
    select: "Vælge",
    is_draw: "Afgøres ved lodtrækning med",
    is_drawn: "Lodtrukket",
    draw_disclaimer: "Hvis der anvendes lodtrækning:",
    num_correct_win: "Antal rigtige/gevinster",
    more_info: "Mere information",
    in_running: "Levende",
    go_back: "Tilbage",
    to_syndicate: "Til fælles kupon",
    shares: "Deler",
    share_price: "Pris pr.del",
    sold_shares: "Solgte deler",
    agent_admin: "Agentadministrator",
    agents: "Agent",
    to_agent: "Vis alle delte spil",
    create_new_syndicate: "Opret nyt fælles kupon",
    name: "Navn",
    target_number_of_shares: "Antal deler",
    max_number_of_shares: "Maksimalt antal deler",
    submit_syndicate: "Indsend delingsspillet",
    update_syndicate: "Opdater delingsspillet",
    show_sv_percent: "Vis pulje%",
    show_coupon_percent: "Vis kupon %",
    number_of_rows: "Antal rækker",
    share_of_syndicate: "Andel af andelen-spillet",
    syndicate_created: "Det kooperative spil skabt",
    syndicate_submitted: "Samarbejdsspillet er blevet indsendt.",
    syndicate_updated: "Samarbejdsspillet er opdateret",
    finished: "Færdiggjort",
    started_games: "Startet",
    potential: "Potentiel",
    sort_by_finished: "Sortér efter fuldført",
    game_summary: "Kampoversigt",
    date: "Dato",
    league: "Liga",
    venue: "Arena",
    latest_tweets: "Seneste tweets fra",
    weather: "Vejr",
    temperature: "Temperatur",
    wind: "Vind",
    moisture: "Fugtighed",
    general_info: "Generelle oplysninger",
    locale: "da-DK",
    show: "Vise",
    show_round: "Vis runde",
    play_on: "Spil videre",
    today: "I dag",
    latest_games: "Seneste kampe",
    head_to_head: "Hoved mod hoved",
    round_information_short: "Info",
    round_information: "Information",
    prize_groups: "Profitgrupper",
    bet: "Spil",
    pro_pick_bets: "Færdiglavede spil",
    help: "Hjælp",
    round_status_open: "Åben",
    round_status_voided: "Annulleret",
    round_status_paused: "Pausesat",
    round_paused_explanation: "Runden er sat på pause, og nye indsatser kan ikke placeres.",
    the_game: "The Game",
    your_picks: "Dine valg",
    quick_pick: "Hurtigvalg",
    clear: "Ryd",
    markets_picked: "{{done}} af {{total}} markeder valgt",
    multi_pick_hint: "Vælg mere end ét svar i et marked for at gardere – hvert ekstra valg giver flere rækker.",
    tg_no_pick: "Vælg",
    tg_one_pick: "1 valg",
    tg_n_picks: "{{count}} valg",
    closes_in: "Lukker om",
    pick_in_more_markets: "Vælg i {{count}} markeder mere",
    pick_in_one_more_market: "Vælg i 1 marked mere",
    my_coupon: "Min kupon",
    best_row_now: "Bedste række lige nu",
    you_still_need: "For {{target}} mangler du stadig",
    correct_now: "Rigtig nu",
    not_now: "Ikke nu",
    tg_won: "Vundet",
    tg_lost: "Tabt",
    tg_settled: "Afgjort",
    cant_happen: "Ikke valgt",
    your_pick: "Dit valg",
    correct_right_now: "Rigtig lige nu",
    markets: "Markeder",
    markets_settled: "Afgjorte markeder {{done}} af {{total}}",
    betting_closed_live: "Spillestop – kampen er i gang",
    tg_match_over: "Kampen er slut",
    play_next_round: "Spil næste runde",
    rows_spread_hint: "Søjlerne viser, hvordan spillernes rækker er fordelt.",
    tg_play: "Spil",
    markets_count: "{{count}} markeder",
    your_best_row_now: "Din bedste række lige nu",
    follow_my_coupon: "Følg min kupon",
    markets_settled_label: "Afgjorte markeder",
    n_of_total: "{{done}} af {{total}}",
    betting_closed: "Spillestop",
    watch_live: "Se live",
    jackpot: "Estimeret jackpot",
    jackpot_alt: "Estimeret jackpot",
    after_extra_time: "Efter forlænget spilletid",
    system_guarantee: "juridisk garanti",
    reduced_disclaimer: "I et reduceret system er antallet af linjer blevet reduceret i forhold til det tilsvarende matematiske system. Dette giver dig en lavere chance for at vinde, men systemet koster også mindre.",
    show_rows: "Vis mine rækker",
    api_betting: "Filupload",
    select_file: "Vælg fil",
    file: "Fil",
    id: "Id",
    upload: "Upload",
    bet_title: "Tip",
    follow_title: "Følge",
    win_title: "Vinde",
    bet_text: "Vælg et eller flere resultater i rundens kampe",
    follow_text: "Følg dine vinderchancer live på siden",
    win_text: "Hvis du får nok rigtige svar, deler du puljen. 80% af indsatserne udbetales som gevinster.",
    share_of_prizepool: "Andel af præmiepuljen",
    register: "Registrér",
    fee_per_row: "Gebyr pr. linje",
    bet_status_open: "Åben",
    bet_status_won: "Vundet",
    bet_status_lost: "Tabt",
    payout: "Betaling",
    show_details: "Vis detaljer",
    bet_now: "Spil nu",
    place_more: "Hvis du vil øge dine vinderchancer, kan du vælge mere end ét resultat i hvert spil.",
    active_syndicates: "aktiv fælles kupon",
    settled_syndicates: "afgjorte fælles kuponer",
    win_multiplier: "Gevinstmultiplikator",
    win_multiplier_information: "Din indsats og potentielle gevinst ganges med den valgte gevinstmultiplikator.",
    status: "Status",
    balance: "Saldo",
    join_title: "Deltag i en fælles kupon",
    join_text: "Deltag i et større system og øg dine chancer for at vinde puljen.",
    valid_title: "Altid gyldig",
    valid_text: "Dit væddemål står, selvom fælles kuponen ikke er udsolgt.",
    win_together_title: "Vind sammen",
    win_together_text: "Overskuddet fra systemet fordeles mellem delerna.",
    fee: "Oplade",
    error_title: "Noget gik galt.",
    error_text: "Prøv at genindlæse siden, eller gå tilbage til forsiden.",
    reload: "Genindlæs",
    odds: "Odds",
    login: "Log ind",
    syndicate_not_finalised: "Kuponen er ikke fastsat.",
    syndicate_show_later: "Fælles kuponen er ikke bestemt. Kuponen vises efter spilstop.",
    win_per_share: "Indtjening pr. del",
    freebet: "Bonusspil",
    login_dialog: "Du skal logge ind for at placere et væddemål.",
    freebet_wrong_covers: "Du har ikke det rigtige antal hel- og halvdækninger. Ret venligst for at kunne placere indsatsen.",
    fill_automatic: "Udfyld automatisk",
    event_faceoff: "Ansigtsaftale",
    fill_coupon: "Udfyld kuponen med",
    and: "og",
    share_coupon: "Del denne kupon",
    copy_link: "Kopier link",
    copied: "Kopieret til udklipsholder",
    ok: "OK",
    real_jackpot: "Jackpot",
    real_jackpot_alt: "Jackpot",
    results: "Resultater",
    live: "Live",
    check_out_my_coupon: "Se min kupon!",
    cash_out_confirm: "Vil du foretage Cash out for {{amount}}?",
    cash_out_selected_amount: "det valgte beløb",
    cash_out_completed: "Cash out gennemført!",
    cash_out_error: "Fejl:",
}